import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThunkRejectedAction } from '../types/redux';
import { submit } from './navigation.thunk';
import { AreaType, BookingOptionType, ClaimType, InsuranceType, NavigationState } from './navigation.type';

export const initialState: NavigationState = {
  area: undefined,
  category: undefined,
  selections: {
    insurance: {
      reviewInsurance: false,
    },
    injury: {
      category: undefined,
    },
    others: {
      reviewInsurance: false,
    },
  },
  bookingOption: 'selectedTime',
  mobile: '',
  submission: {
    status: 'idle',
    done: false,
  },
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    selectArea: (state, { payload }: PayloadAction<AreaType>) => {
      state.area = payload;
    },
    selectCategory: (state, { payload }: PayloadAction<Pick<NavigationState, 'category'>>) => {
      state.category = payload.category;
    },
    selectInsuranceCategory: (state, { payload }: PayloadAction<InsuranceType>) => {
      state.selections.insurance.category = payload;
    },
    selectClaimCategory: (state, { payload }: PayloadAction<ClaimType>) => {
      state.selections.injury.category = payload;
    },
    selectBookingType: (state, { payload }: PayloadAction<BookingOptionType>) => {
      state.bookingOption = payload;
    },
    selectBookingDate: (state, { payload }: PayloadAction<string>) => {
      state.bookingDate = payload;
      state.bookingTime = undefined;
    },
    selectBookingTime: (state, { payload }: PayloadAction<string>) => {
      state.bookingTime = payload;
    },
    saveCategoryComment: (state, { payload }: PayloadAction<string>) => {
      state.selections.others.comment = payload;
    },
    saveInsuranceComment: (state, { payload }: PayloadAction<string>) => {
      state.selections.insurance.comment = payload;
    },
    saveClaimComment: (state, { payload }: PayloadAction<string>) => {
      state.selections.injury.comment = payload;
    },
    updateReviewConsent: (state, { payload }: PayloadAction<boolean>) => {
      if (state.category === 'insurance' || state.category === 'others') {
        state.selections[state.category].reviewInsurance = payload;
      }
    },
    updateMobile: (state, { payload }: PayloadAction<string>) => {
      state.mobile = payload;
    },
  },
  extraReducers: {
    [submit.pending.toString()]: (state) => {
      state.submission.status = 'loading';
      state.submission.knownError = undefined;
      state.submission.error = undefined;
    },
    [submit.rejected.toString()]: (state, error: ThunkRejectedAction<typeof submit>) => {
      state.submission.status = 'error';
      if (!!error.payload) {
        state.submission.knownError = error.payload;
        if (error.payload === 'time-slot-not-available') {
          delete state.bookingDate;
          delete state.bookingTime;
        }
      } else {
        state.submission.error = error.error.message;
      }
    },
    [submit.fulfilled.toString()]: (state) => {
      state.submission.status = 'idle';
      state.submission.done = true;
    },
  },
});

export const navigationReducer = navigationSlice.reducer;
export const navigationActions = navigationSlice.actions;
